<template>
  <div>
    <template v-if="isDeparture">
      <plan-date
        :isDeparture="isDeparture"
        :isHighlight="isDeparture"
        :date="route.departureTime"
        :inJapan="true" />
    </template>
    <template v-else>
      <plan-date
        :isDeparture="isDeparture"
        :isHighlight="isDeparture"
        :date="route.departureTime"
        :inJapan="true" />
    </template>
    <div class="course-place course-place-in-japan is-station text-btn_secondary border">
      <div class="station-info">
        <div class="course-time text-right font-bold">
          <p class="single">
            {{ time }}
          </p>
        </div>
        <div class="course-place-info-number w-6 h-6 text-center border font-bold text-white flex-shrink-0">
          {{ routeIndex + 1 }}
        </div>
        <div class="course-name text-lg text-body font-bold">
          {{ station.name }}
        </div>
        <div class="plan-icon ml-1 mr-2">
          <a @click="showMap">
            <img src="@/assets/images/icon-plan-map.svg" :alt="$t('map_label')" />
          </a>
        </div>
      </div>
      <div v-if="editable" class="self-start">
        <div class="button-edit-is-arrival">
          <place-button :action="showDepartureModal" :name="buttonLabel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlaceButton from "../atoms/PlaceButton"
import PlanDate from "../molecules/PlanDate"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    PlaceButton,
    PlanDate
  },
  props: {
    station: {
      type: Object,
      required: true
    },
    showDepartureModal: {
      type: Function,
      required: true
    },
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    isDeparture: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    route: {
      type: Object,
      default: function () {
        return {
          departureTime: moment(),
          arrivalTime: moment()
        }
      }
    },
    routeIndex: {
      type: Number,
      required: true
    }
  },
  methods: {
    showMap: function () {
      const location = this.station.location
      const params = {
        lat: location.latitude,
        lng: location.longitude
      }
      this.$store.dispatch('map/updateCenter', params)
      this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'] } })
    }
  },
  computed: {
    label: function () {
      return this.isDeparture ? this.$t('departure_label') : this.$t('arrival_label')
    },
    buttonLabel: function () {
      return this.isDeparture ? this.$t('change_departure_label') : this.$t('change_arrival_label')
    },
    time: function () {
      const t = this.isDeparture ? this.route.departureTime : this.route.arrivalTime
      return t.format("HH:mm")
    }
  }
}
</script>
